import de from './de'
import en from './en'

export { de, en }

export type MessageSchema = typeof de

export const messages = {
  de,
  en
}

export const defaultLocale = 'en'
export const availableLocales = ['de', 'en'] as const
export type Locale = (typeof availableLocales)[number]
